import { createStore } from "vuex";
import auth from "./modules/auth";
import onboard from "./modules/onboard";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    onboard,
  },
});
